(() => {
  if (window.CustomDynamicCarousel) {
    console.log("Carousel already initialized");
    return;
  }

  class Carousel {
    constructor(carousel, mobileCarousel) {
      this.carousel = carousel;
      this.mobileCarousel = mobileCarousel;
      this.currentSlide = 0;
      this.init();
    }

    goToSlide(index, slides) {
      if (index < 0 || index >= slides.length) {
        return;
      }
      const left = this.mobileCarousel.querySelector(".icon-chevron.left-nav");
      const right = this.mobileCarousel.querySelector(
        ".icon-chevron.right-nav"
      );
      if (index === 0) {
        left.classList.add("disabled");
      } else {
        left.classList.remove("disabled");
      }
      if (index === slides.length - 1) {
        right.classList.add("disabled");
      } else {
        right.classList.remove("disabled");
      }
      this.currentSlide = index;
      const scrollPosition = slides[this.currentSlide].offsetLeft;
      this.mobileCarousel
        .querySelector(".custom-dynamic-banner-carousel__main-container")
        .scrollTo({
          left: scrollPosition,
          behavior: "smooth",
        });
    }

    initEvents() {
      if (!this.mobileCarousel) {
        return;
      }
      const slides = this.carousel.querySelectorAll(
        ".custom-dynamic-banner-carousel__container"
      );
      const mobileSlides = this.mobileCarousel.querySelectorAll(
        ".custom-dynamic-banner-carousel__container"
      );
      const buttons = this.mobileCarousel.querySelectorAll(".icon-chevron");
      buttons.forEach((el) => {
        el.addEventListener("click", () => {
          const increment = parseInt(el.dataset.increment);
          this.goToSlide(this.currentSlide + increment, mobileSlides);
        });
      });
      slides.forEach((el, index) => {
        el.addEventListener("click", () => {
          this.mobileCarousel.classList.toggle("active");
          this.goToSlide(index, Array.from(mobileSlides));
        });
      });
      this.mobileCarousel
        .querySelector(".halo-sidebar-close")
        .addEventListener("click", (e) => {
          e.preventDefault();
          this.mobileCarousel.classList.remove("active");
        });
    }

    init() {
      this.initEvents();
    }
  }

  const carousels = document.querySelectorAll("ff-dynamic-carousel");

  carousels.forEach((carouselElement) => {
    const mobileCarousel = carouselElement.nextElementSibling;
    new Carousel(carouselElement, mobileCarousel);
  });

  window.CustomDynamicCarousel = carousels;
})();
